import React from 'react';
import { useTranslation } from 'react-i18next';

export const InfoClause = () => {
    const { t } = useTranslation();
    return (
        <p>
            {t('contact.contactForm.accordion.p1')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p2')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p3')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p4')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p5')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p6')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p7')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p8')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p9')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p10')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p11')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p12')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p13')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p14')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p15')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p16')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p17')}
            <br />
            <br />
            {t('contact.contactForm.accordion.p18')}
            <br />
            {t('contact.contactForm.accordion.p19')}
            <br />
            {t('contact.contactForm.accordion.p20')}{' '}
            <a href="mailto:aktualnosci@ecolab.com">aktualnosci@ecolab.com</a>
        </p>
    );
};
